const DEVICE_STATUS = {
  ONLINE: 'Online',
  OFFLINE: 'Offline',
  PAUSED: 'Paused',
};

export { DEVICE_STATUS };
